import { Box, Typography } from '@material-ui/core';
import React from 'react';
import TerminatedTile from '../../reusable-components/TerminatedTile';
import useStyles from './myServicesStyles';
import { ACCOUNT_STATUS } from '../../../components/myeirconstant/myEirConstant';
import theme from '../../../theme/MyEirTheme';

function ServicesInfo({
    title,
    offerName,
    number,
    errorMessage,
    contractType,
    orderStatus,
    showESIMFlash,
    numCards,
}) {
    const classes = useStyles();
    const userStatus = sessionStorage.getItem('Account_status');
    let input = number;
    let result =
        input !== null
            ? input
                  .replace(/null/g, '')
                  .replace(/\s*\|\s*/g, '|')
                  .replace(/\|+/g, ' | ')
                  .replace(/^\s*\|\s*|\s*\|\s*$/g, '')
                  .trim()
            : '';
    let array = result.split('|');
    let updatedArray = array.map(item => item.replace(/-/g, ' '));
    let uniqueArray = updatedArray
        .map(value => value.trim())
        .filter((value, index, self) => {
            return value !== '' && self.indexOf(value) === index;
        });

    let finalResult = uniqueArray.join(' | ');
    return (
        <>
            <Box className={classes.typeWithTitle}>
                <Typography
                    variant='p'
                    component='p'
                    className={classes.mainHeading}
                    style={theme.typography.subtitle3}
                >
                    {' '}
                    {title}{' '}
                </Typography>
                {contractType && <Box className={classes.type}> {contractType} </Box>}
                {orderStatus && <Box className={classes.preOrderType}> {orderStatus} </Box>}
                {/* Enable eSIM Feature */}
                {JSON.parse(sessionStorage.getItem('LoggedinUserFeatures'))?.filter(
                    feature => feature?.feature_name === 'esim'
                ).length > 0 &&
                    showESIMFlash && (
                        <Box
                            className={
                                numCards === 1
                                    ? classes.flashWrapperSingleCard
                                    : classes.flashWrapper
                            }
                        >
                            <Typography className={classes.eSimFlash}>eSIM Inactive</Typography>
                        </Box>
                    )}
            </Box>
            <Typography
                variant='p'
                component='p'
                className={classes.subHeading}
                style={theme.typography.subtitle1}
            >
                {offerName}
            </Typography>
            {errorMessage != '' ? (
                <Typography
                    className={
                        orderStatus !== 'Pre-order'
                            ? classes.inactiveErrorText
                            : classes.preOrderErrorText
                    }
                >
                    {errorMessage}
                </Typography>
            ) : (
                <Typography className={classes.phoneNumber} style={theme.typography.body1}>
                    {finalResult.split('|').map((item, index, arr) => {
                        const trimmed = item.trim();
                        return (
                            <React.Fragment key={index}>
                                <p>{trimmed}</p>
                                {/**Add visually visible separator but hide from screen readers */}
                                {index < arr.length - 1 && <span aria-hidden='true'> |</span>}
                            </React.Fragment>
                        );
                    })}
                </Typography>
            )}
            {userStatus === ACCOUNT_STATUS.BILLABLE_EMPTY ||
            userStatus === ACCOUNT_STATUS.UNBILLABLE ? (
                <TerminatedTile terminatedCopy='This service is no longer active' />
            ) : (
                ''
            )}
        </>
    );
}

export default ServicesInfo;
